<template>
  <div>
    <v-card>
      <div class="pa-4">
        <v-row
          no-gutters
          :class="{ 'mb-4' : $vuetify.breakpoint.smAndDown }"
        >
          <div
            :class="
              $vuetify.breakpoint.xs
                ? 'd-flex mx-1 my-2'
                : 'd-flex align-center'
            "
            :style="$vuetify.breakpoint.xs && 'width: 100%;'"
          >
            <div
              :class="$vuetify.breakpoint.xs ? 'd-flex' : 'd-flex align-start'"
              style="width: 100%;"
            >
              <div
                class="d-flex flex-column"
                style="width: 100%"
              >
                <strong
                  class="mr-1"
                >
                  {{ $t("cpaValue") }}:
                  {{ cpaType == 1 ? $t("labelCurrency") : "" }}
                  {{ cpaValue || " 0.00" }}{{ cpaType == 2 ? "%" : "" }}
                </strong>
                <strong class="mr-2">
                  {{ $t("typeOfCPA") }}: {{ handleCPAType(cpaType) || $t('notFound') }}
                </strong>
              </div>
            </div>
          </div>

          <v-spacer></v-spacer>
          <v-col cols="12" sm="4" md="4">
            <div>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                :class="{ 'mt-2' : $vuetify.breakpoint.smAndDown }"
                single-line
                hide-details
                solo-inverted
                clearable
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-spacer class="my-2" />
        <v-data-table
          :headers="headers"
          :items="cpaItems"
          :search="search"
          class="mb-4"
          :no-data-text="$t('noDataForthisQuery')"
          :no-results-text="$t('noDataForthisQuery')"
          :footer-props="{
            'items-per-page-text': $t('rowsPerPage'),
            'items-per-page-options': [5, 10, 15],
          }"
        >
        
          <template v-slot:item.player_id="{ item }">
            <v-btn
              @click="$copy(item.player_id)"
              x-small
            >
              {{ item.player_id }}
            </v-btn>
          </template>

          <template v-slot:item.player_first_deposit="{ item }">
            <div class="grey--text">
              {{ `${$t("labelCurrency")} ${addZeroes(item.player_first_deposit)}` }}
            </div>
          </template>

          <template v-slot:item.commissions="{ item }">
            <div :class="getColor(item.commissions)">
              {{ `${$t("labelCurrency")} ${addZeroes(item.commissions)}` }}
            </div>
          </template>

          <template v-slot:item.date_register="{ item }">
            <div :class="{ 'caption' : $vuetify.breakpoint.xs }">
              {{ handleDate(item.date_register) }}
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div>
      <Resume
        :data_resume="{
          data: [...cpaItems, ...countFirstDeposits],
          keys: [
            'commissions',
            'player_first_deposit',
            'qtd_deposits',
          ],
          hideAlert: true
        }"
      />
    </div>
  </div>
</template>
<script>
import Resume from "@/components/backoffice/resume_global/resume";

export default {
  name: "AgentFinancialCpa",

  components: {
    Resume,
  },

  data: (self) => ({
    search: "",
    cpaValue: "",
    cpaType: "",
    cpaItems: [],
    countFirstDeposits: { qtd_deposits: 0 },
    headers: [
      { text: self.$t("playerId"), value: "player_id" },
      { text: self.$t("firstDeposit"), value: "player_first_deposit" },
      { text: self.$t("commission"), value: "commissions" },
      { text: self.$t("registerDate"), value: "date_register" },
    ],
  }),

  computed: {
    // Global Filters
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  mounted() {
    this.getCPAData();
  },

  watch: {
    saveFilters(val) {
      val && this.getCPAData();
    },
  },

  methods: {
    getCPAData() {
      this.reset();

      const body = {
        ...this.rangeGlobalDate,
        type: "list",
      }

      this.$axios.post("/agent/financial/affiliatesCpa", this.$formdata(body))
        .then((response) => {
          this.cpaItems = response.data.dados[0].cpa_details;
          // Fazendo a contagem dos depósitos
          this.cpaItems.forEach((player) => {
            player.player_first_deposit &&
            this.countFirstDeposits.qtd_deposits ++;
          })
          this.cpaValue = response.data.dados[0].cpa_value
          this.cpaType = response.data.dados[0].cpa_type
        })
        .catch(() => {});
    },

    reset() {
      this.cpaItems = [];
      this.cpaValue = "";
      this.cpaType = "";
      this.countFirstDeposits = { qtd_deposits: 0 };
    },

    handleCPAType(type) {
      if (type == 1) {
        return `${this.$t('fixedCommission')} (${this.$t('labelCurrency')})`
      }
      if (type == 2) {
        return `${this.$t('percent')} (%)`
      }
    },

    handleDate(date) {
      return new Date(date).toLocaleString()
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    addZeroes(num) {
      if (typeof num !== "string") {
        num = num.toString();
      }

      const dec = num.split(".")[1];
      const len = dec && dec.length > 2 ? dec.length : 2;
      return Number(num).toFixed(len);
    },
  },
};
</script>